import React, {useState} from "react";
import {Link, router} from "@inertiajs/react";
import {Alert, Button, Card, Table} from "react-bootstrap";
import RecipientImportModal from "../RecipientImportModal.jsx";

/**
 * Schritt 3 des Kampagnen-Assistenten: Empfänger aus Excel importieren.
 * Zeigt nach dem Import eine kompakte Vorschau + Zähler; die vollständige
 * Empfänger-Tabelle mit Status/Filter lebt auf der Kampagnen-Ansicht
 * (Recipients.jsx), auf die von hier aus verlinkt wird.
 */
export default function StepEmpfaenger({campaign, recipientsCount, recipientsPreview}) {
    const [showImport, setShowImport] = useState(false);

    if (!campaign) {
        return (
            <Card>
                <Card.Body>
                    <p className="text-muted">
                        Empfänger werden aus einer Excel-Datei importiert.
                    </p>
                    <Alert variant="info" className="mb-0">
                        Bitte zuerst Schritt 1 mit „Weiter" speichern - erst dann kann
                        Empfängern eine Kampagne zugeordnet werden.
                    </Alert>
                </Card.Body>
            </Card>
        );
    }

    return (
        <Card>
            <Card.Body>
                <p className="text-muted">
                    Hier lädst du die Excel-Liste mit den Empfängern hoch (Sheet
                    „Mail-Liste"). Ohne Empfänger kann die Kampagne nicht gestartet
                    werden.
                </p>

                <div className="d-flex align-items-center gap-3 mb-3">
                    <Button variant="primary" onClick={() => setShowImport(true)}>
                        Aus Excel importieren
                    </Button>
                    <div>
                        <strong>{recipientsCount ?? 0}</strong> Empfänger aktuell importiert.
                    </div>
                </div>

                {(recipientsCount ?? 0) === 0 && (
                    <Alert variant="warning">
                        Noch keine Empfänger importiert. Ohne Empfänger kann nicht gestartet werden.
                    </Alert>
                )}

                {recipientsPreview && recipientsPreview.length > 0 && (
                    <>
                        <div className="mb-2"><strong>Vorschau (erste {recipientsPreview.length} Empfänger)</strong></div>
                        <div className="table-responsive">
                            <Table size="sm" bordered className="mb-2">
                                <thead>
                                <tr>
                                    <th>Schule</th>
                                    <th>Stadt</th>
                                    <th>E-Mail</th>
                                    <th>Schulform</th>
                                    <th>Frühester Versand</th>
                                </tr>
                                </thead>
                                <tbody>
                                {recipientsPreview.map((row) => (
                                    <tr key={row.id}>
                                        <td>{row.school_name}</td>
                                        <td>{row.city}</td>
                                        <td>{row.email}</td>
                                        <td>{row.school_type}</td>
                                        <td>{row.earliest_send_at}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        </div>
                    </>
                )}

                <Link href={`/campaigns/${campaign.id}/recipients`} className="btn btn-outline-secondary btn-sm">
                    Alle Empfänger im Detail ansehen
                </Link>

                <RecipientImportModal
                    show={showImport}
                    campaignId={campaign.id}
                    onClose={() => {
                        setShowImport(false);
                        router.reload({only: ["recipientsCount", "recipientsPreview"]});
                    }}
                />
            </Card.Body>
        </Card>
    );
}
